import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  backgroundCheck: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'background-check' }),
}

export { paths }
